import { writable } from "svelte/store";

export const csrfStore = writable("");

export async function waitForCSRFToken() {
    return new Promise((resolve) => {
        const unsubscriber = csrfStore.subscribe((token) => {
            if (token) {
                unsubscriber();
                resolve(token);
            }
        });
    });
}
